import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import routeList from "./config";
import store from "../store";

const loginName = "login";

const routes: Array<RouteRecordRaw> = routeList;

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

const checkPermission: any = (menus: any, key: string) => {
  let result = false;
  for (const item of menus) {
    if (item.key && item.key === key) {
      result = true;
    } else if (item.children) {
      result = checkPermission(item.children, key);
    }
    if (result === true) {
      break;
    }
  }
  return result;
};

router.beforeEach((to, from, next) => {
  // title
  const titles = store.getters.assnUserTitles;
  const key = to.params.key;
  const mKey = (to.name as any) + (key ? key : "");
  if (key !== undefined && titles[mKey] !== undefined) {
    to.meta.title = titles[mKey];
  }
  const loggedAuth = to.matched.some(
    (r) => r.meta.loggedAuth || r.meta.loggedAuth === undefined
  );
  const menus = store.getters.assnUserMenus;
  const check = checkPermission(menus, mKey);
  let n = null;
  console.log(store.getters.assnUser);
  if (loggedAuth && !store.getters.assnUserToken) {
    n = { name: loginName, query: { redirect: to.fullPath } };
  } else if (
    !loggedAuth &&
    (store.getters.assnUserToken || to.name === undefined)
  ) {
    n = { name: "home" };
  } else if (
    store.getters.assnUserToken &&
    !store.getters.assnUser.code &&
    to.name !== "home" &&
    to.name !== "setting"
  ) {
    n = { name: "setting" };
  } else if (store.getters.assnUserToken && to.name !== "home" && !check) {
    n = { name: "home" };
  }
  next(n!);
});

export default router;
